export default __webpack_public_path__ + "static/media/thankImg.9421cd8e.png";